import React from "react";
import { Container, Row, Col } from "reactstrap";

//Import Images - Fotos del equipo desde src/assets/images/team/
import imgJoseLuisCruz from "../../../assets/images/team/joseLuisCruz.jpg";
import imgKatherinDelgado from "../../../assets/images/team/katherinDelgado.jpg";
import imgEmilsenDelgado from "../../../assets/images/team/EmilsenDelgado.jpg";
import imgNataliaPeralta from "../../../assets/images/team/nataliaPeralta.jpg";
import imgAdrianaCamacho from "../../../assets/images/team/adrianaCamacho.jpg";
import imgCamiloMoreno from "../../../assets/images/team/CamiloMoreno.jpg";
import imgAlexisVelasquez from "../../../assets/images/team/alexisVelasquez.jpg";

const TeamPage = () => {
  const teamPage = [
    {
      id: 1,
      teamMemberImage: imgJoseLuisCruz,
      teamMemberName: "Jose Luis Cruz O.",
      teamMemberPosition: "CEO",
      profileUrl: "https://www.linkedin.com/in/jose-luis-cruz-osorio",
      profileLabel: "LinkedIn"
    },
    {
      id: 2,
      teamMemberImage: imgKatherinDelgado,
      teamMemberName: "Katherin Delgado Z.",
      teamMemberPosition: "Directora de operaciones",
      profileUrl: "https://www.linkedin.com/in/katherin-delgado-zapata-37207a173/",
      profileLabel: "LinkedIn"
    },
    {
      id: 3,
      teamMemberImage: imgEmilsenDelgado,
      teamMemberName: "Emilsen Delgado Z.",
      teamMemberPosition: "Directora de Nómina",
      profileUrl: "https://www.linkedin.com/in/emilsen-delgado-zapata-6a0b7550/",
      profileLabel: "LinkedIn"
    },
    {
      id: 4,
      teamMemberImage: imgNataliaPeralta,
      teamMemberName: "Natalia Peralta D.",
      teamMemberPosition: "HRBP",
      profileUrl: "https://www.linkedin.com/in/lesly-natalia-peralta-delgado",
      profileLabel: "LinkedIn"
    },
    {
      id: 5,
      teamMemberImage: imgAdrianaCamacho,
      teamMemberName: "Adriana Camacho A.",
      teamMemberPosition: "Líder de Selección",
      profileUrl: "https://www.linkedin.com/in/luz-adriana-camacho-angulo/",
      profileLabel: "LinkedIn"
    },
    {
      id: 6,
      teamMemberImage: imgCamiloMoreno,
      teamMemberName: "Camilo Moreno",
      teamMemberPosition: "Director de seguridad Cibernética",
      profileUrl: "https://torre.ai/camilom22",
      profileLabel: "Torre.ai"
    },
    {
      id: 7,
      teamMemberImage: imgAlexisVelasquez,
      teamMemberName: "Alexis Velasquez",
      teamMemberPosition: "Director Contable y Financiero",
      profileUrl: "https://www.linkedin.com/in/johan-alexis-velasquez-delgado-a0125218a/",
      profileLabel: "LinkedIn"
    }
  ];
  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row>
            {teamPage.map((teamPageDetails, key) => (
              <Col lg={4} md={6} key={key}>
                <div className="team-box card border-0 mt-4">
                  <div className="team-img position-relative mx-auto">
                    <img
                      src={teamPageDetails.teamMemberImage}
                      alt={teamPageDetails.teamMemberName}
                      className="img-thumbnail"
                    />
                    <ul className="team-social list-unstyled">
                      <li>
                        <a
                          href={teamPageDetails.profileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={teamPageDetails.profileLabel}
                        >
                          <i className={teamPageDetails.profileLabel === "Torre.ai" ? "mdi mdi-web" : "mdi mdi-linkedin"}></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="team-content card-body text-center">
                    <a
                      href={teamPageDetails.profileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="primary-link"
                    >
                      <h6 className="fs-17 mb-1">
                        {teamPageDetails.teamMemberName}
                      </h6>
                    </a>
                    <p className="text-muted mb-0">
                      {teamPageDetails.teamMemberPosition}
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default TeamPage;
